import { Component, OnInit } from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { AddCrowdsaleComponent } from "../add-crowdsale/add-crowdsale.component";

@Component({
    selector: "ngx-page-not-found",
    templateUrl: "./page-not-found.component.html",
    styleUrls: ["./page-not-found.component.scss"],
    // template: `

    // `
})
export class PageNotFoundComponent implements OnInit {
    constructor(private _dS: NbDialogService) {}

    ngOnInit(): void {}

    onAddContractAddress() {
        this._dS.open(AddCrowdsaleComponent, { autoFocus: false });
    }
}
